<ng-container *transloco="let _t">


<p><mat-icon color="warn">warning</mat-icon><strong>{{ _t('audit-back-dialog-strong-0') }}</strong> {{ _t('audit-back-dialog-p-0') }}</p>
<button mat-raised-button color="accent" (click)="choose(1)" >
	<mat-icon>youtube_searched_for</mat-icon> &nbsp;
	<span>{{ _t('audit-back-dialog-span-0') }}</span>
</button>


<button mat-raised-button color="primary" (click)="choose(2)" >
	<mat-icon>location_city</mat-icon> &nbsp;
	<span>{{ _t('audit-back-dialog-span-1') }}</span>
</button>


<button mat-raised-button color="secondary" (click)="choose(0)" >
	<mat-icon>close</mat-icon> &nbsp;
	<span>{{ _t('audit-back-dialog-span-2') }}</span>
</button>



</ng-container>